<div class="container-fluid">
  <div class="modal-header modal-header--bordered d-flex align-items-center justify-content-between">
    <h3 class="modal-title">
      {{ 'tkey;migrations.cisco.reports_list.table.download_files.modal.title' | translate }}
    </h3>
    <button
      type="button"
      data-automation="detailed-modal-close-button"
      class="btn-close"
      aria-label="Close"
      (click)="onClose()"
    ></button>
  </div>
  <div class="modal-body">
    <h6
      class="mb-3"
      [innerHTML]="
        'tkey;migrations.cisco.reports_list.table.download_files.modal.description'
          | escapeHtml: { pbxName: modalProperties.reportTitle }
      "
    ></h6>
    <div class="row">
      <div class="col-md-12">
        <ul class="list-group list-group-striped mb-3 border-rad-all-12 card-shadow">
          @for (key of getButtonKeys(); track $index) {
            @let button = modalProperties.buttons[key];
            <li class="list-group-item">
              <div class="d-md-flex align-items-center justify-content-between d-block">
                <div>
                  <h5 class="strong">
                    {{ button.title | translate }}
                  </h5>
                  <p>
                    {{ button.description | translate }}
                  </p>
                </div>
                <ziro-button
                  [dataAutomation]="`download-${key}-button`"
                  (clicked)="downloadFile(key, button)"
                  [isDisabled]="!button.uri"
                  [tooltip]="'tkey;migrations.cisco.reports_list.table.download_files.modal.button.disabled.tooltip'"
                  [isTooltipDisabled]="!!button.uri"
                  [isPending]="button?.isPending"
                  [icon]="icons.DOWNLOAD"
                  [iconPending]="icons.SAVING"
                  [buttonStyle]="buttonStyle.DEFAULT"
                  [buttonSize]="buttonSizes.MEDIUM"
                  [label]="button.label"
                ></ziro-button>
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
</div>
